<footer class="footer footer-static footer-light ">
  <p class="clearfix mb-0 ">
        <span class="float-md-left d-block d-md-inline-block mt-25 ">Copyright &copy; {{ year }}
          <!--        <a class="ml-25 " href="#" onclick="return false;" target="_blank ">-->
          Globalredpyme, Derechos reservados
          <!--        </a>-->
        </span>
  </p>
</footer>
<button class="btn btn-primary btn-icon scroll-top" type="button" (click)="scrollToTop()">
  <i data-feather="arrow-up"></i>
</button>
